import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';

/** Call once at app root. Picks up ?token= or #token= from OAuth redirect and loads user profile. */
export function useAuthInit() {
  const token = useAuthStore((s) => s.token);
  const setToken = useAuthStore((s) => s.setToken);
  const fetchMe = useAuthStore((s) => s.fetchMe);

  useEffect(() => {
    // Check query string first (?token=...) — back-compat during deploy overlap
    const params = new URLSearchParams(window.location.search);
    const queryToken = params.get('token');

    // Also check URL fragment (#token=... may coexist with other hash content)
    const hashStr = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
    const hashParams = new URLSearchParams(hashStr);
    const hashToken = hashParams.get('token');

    const urlToken = queryToken ?? hashToken;
    if (urlToken) {
      setToken(urlToken);

      // Strip token from query string
      params.delete('token');
      const cleanSearch = params.toString() ? `?${params.toString()}` : '';

      // Strip token from hash, preserving any other hash content
      hashParams.delete('token');
      const remainingHash = hashParams.toString();
      const cleanHash = remainingHash ? `#${remainingHash}` : '';

      window.history.replaceState({}, '', window.location.pathname + cleanSearch + cleanHash);
    }
  }, [setToken]);

  useEffect(() => {
    if (token) fetchMe();
  }, [token, fetchMe]);
}
